var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isLoading && _vm.hasOrder)?_c('RouterView'):_vm._e(),(_vm.isLoading)?_c('div',{staticClass:"p-3 mb-3"},[_c('i',{staticClass:"fad text-danger fa-spinner fa-spin mr-4"}),_vm._v("Nahrávám ... ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }